module.exports = __webpack_public_path__ + "img/art-composer-postcard.41e1d239.png";